import AdvocateSrinityaDetails from '../../components/about/advocates-details/srinitya';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateSrinityaDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Srinitya Jaiteerth Joshi'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Srinitya Jaiteerth Joshi'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateSrinityaDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateSrinityaDetailsPage;

